import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import { motion } from 'framer-motion';
import Loader from 'svg/loader.svg';
const ButtonLoader = ({ isInitInProgress })=>/*#__PURE__*/ _jsx(motion.div, {
        initial: {
            x: isInitInProgress ? 0 : '100%'
        },
        animate: {
            x: 0
        },
        exit: {
            x: '100%'
        },
        transition: {
            ease: 'easeOut',
            duration: 0.15
        },
        className: "btn__loaderWrapper",
        children: /*#__PURE__*/ _jsx(Loader, {
            className: "btn__loader rotatingLoader"
        })
    });
export default /*#__PURE__*/ memo(ButtonLoader);
